export default __webpack_public_path__ + "static/media/video5.04d85218.mp4";